import { render } from "./Login.vue?vue&type=template&id=49b54c5c&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=49b54c5c&scoped=true&lang=css"

import exportComponent from "/home/chris/Documents/HELSINKI/Uni_IFT/truscanWebapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b54c5c"]])

export default __exports__